import AjaxUtils from './ajaxUtils';
const updatePrivacyConsent = data => AjaxUtils.post('/v2/browser-privacy-consent', data);
const fetchUserCompanyInfo = () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/company/me`, true);
const logout = () => AjaxUtils.delete(`${envConfig.PLATFORM_SERVER_URL}/v2/logout`, true);
const fetchReferralUsage = () => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/account-referrals`, true);
const fetchContactLocations = query => AjaxUtils.get(`${envConfig.PLATFORM_SERVER_URL}/v2/filters/contactLocation?text=${query}`, true);
export { fetchContactLocations, fetchReferralUsage, fetchUserCompanyInfo, logout, updatePrivacyConsent };
